import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'
import Store from '@/store'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Login',
        component: Login,
        meta: { isPublic: true , requiresAuth:false}
    },
    {
        path: '/Menu',
        name: 'Menu',
        component: () => import(/* webpackChunkName: "menu" */'../views/Menu.vue'),
        meta: { requiresAuth: false}
    },
    {
        path: '/AttendanceEntry',
        name: 'AttendanceEntry',
        component: () => import(/* webpackChunkName: "attendance-entry" */ '../views/AttendanceEntry.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/EmployeeMaster',
        name: 'EmployeeMaster',
        component: () => import(/* webpackChunkName: "employee-master" */ '../views/EmployeeMaster.vue'),
        meta: { requiresAuth: true, allowedRoles: ['roleBusinessAdmin', 'roleWorkingHoursAdmin']  }
    },
    {
        path: '/EmployeeMasterEdit',
        name: 'EmployeeMasterEdit',
        props: true,
        component: () => import(/* webpackChunkName: "employee-master-edit" */ '../views/EmployeeMasterEdit.vue'),
        meta: { requiresAuth: true, allowedRoles: ['roleBusinessAdmin', 'roleWorkingHoursAdmin'] }
    },
    {
        path: '/WorkingList',
        name: 'WorkingList',
        component: () => import(/* webpackChunkName: "working-list" */ '../views/WorkingList.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/Error',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
        meta: { requiresAuth: false }
    },
    {
        path: '/MonthlyTabulation',
        name: 'MonthlyTabulation',
        component: () => import(/* webpackChunkName: "monthl-tabulation" */ '../views/MonthlyTabulation.vue'),
        meta: { requiresAuth: true, allowedRoles: ['roleSales', 'roleLeader', 'roleManager', 'roleBusinessAdmin','roleWorkingHoursAdmin'] }
    },
    {
        path: '/ApplicationList',
        name: 'ApplicationList',
        component: () => import(/* webpackChunkName: "application-list" */ '../views/ApplicationList.vue'),
        meta: { requiresAuth: false }

    },
    {
        path: '/EmployeePasswordEdit',
        name: 'EmployeePasswordEdit',
        component: () => import(/* webpackChunkName: "employee-password-edit" */ '../views/EmployeePasswordEdit.vue'),
        meta: { requiresAuth: false }

    },
    {
        path: '/TrainPassApplication',
        name: 'TrainPassApplication',
        component: () => import(/* webpackChunkName: "train-pass-application" */ '../views/TrainPassApplication.vue'),
        meta: { requiresAuth: false }

    },
    {
        path: '/Sample',
        name: 'Sample',
        component: () => import(/* webpackChunkName: "sample" */ '../views/Sample.vue'),
        meta: { requiresAuth: true, allowedRoles: ['roleManager', 'roleWorkingHoursAdmin'] }
    },
    {
        path: '/CostList',
        name: 'CostList',
        component: () => import(/* webpackChunkName: "sample" */ '../views/CostList.vue'),
        meta: { requiresAuth: false }

    }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// router�ɂ���ʑJ�ڑO�ɋ��ʂōs������
router.beforeEach((to, from, next) => {
    const isBack = (to.params as any)?.isBack === true

    //�߂�{�^���ɂ��J�ڂłȂ���Η����ɒǉ�
    if (to.name && !isBack) {
        Store.commit('navigation/ADD_HISTORY', {
            name: to.name,
            params: { ...to.params }
        })
    }

    const currentUserRoles = Store.getters.userRoles;
    if (to.matched.some(page => page.meta.isPublic) || (Store.state.userToken)) {
        //// ���O�C���ς݂̏ꍇ
        if (to.matched.some(record => record.meta.requiresAuth)) {
            //�����ɂ��A�N�Z�X��������̃y�[�W�̏ꍇ
            if (!Store.state.roles) {
                //�������ݒ�

                next('/Menu');//���j���[�փ��_�C���N�g
            } else if (to.meta.allowedRoles && !to.meta.allowedRoles.some((role: any) => currentUserRoles[role])) {
                //�������s�K�i�̏ꍇ

                next('/Menu');//���j���[�փ��_�C���N�g
            } else {
                // ���y�[�W��
                next();
            }
        } else {
            //�����ɂ��A�N�Z�X�����Ȃ��̃y�[�W
            //���y�[�W��
            next();
        }
    } else {

        // ���O�C���ς݂łȂ��ꍇ�̓��O�C����ʂɃ��_�C���N�g
        next('/')
    }
})

export default router
